<template>
  <div>
    <counterDays />
    <div class="row">
      <div class="col">
        <!-- <div class="w-100 f-center">
          <h4 class="text-center">טאבון Napoli האהוב השתדרג עם שם חדש! קבלו את Bertello🔥 </h4>
        </div> -->
        <div class="w-100 center-all mb-2">
          <img src="../assets/ass1.jpg" alt="">
        </div>
      </div>
    </div>
    <OnNapoli />
    <videoTop src="https://cdn.shopify.com/s/files/1/0011/6195/3290/files/Untitled_Project_7.mp4?v=1627671691" />
    <ReelPizza />
    <iconsBanner />
    <GasBurner />
    <videoTop src="https://cdn.shopify.com/s/files/1/0011/6195/3290/files/napoli_wood_flame2.mp4?6785760937562698444" />
    <FoodImages />
    <SoWhy />
    <questions class="mobile" />
    <RecipesLink />
    <videoBottom width="width-video-50"
      srcVideo="videos/v1.mp4" />
  </div>
</template>

<script>
  /* eslint-disable */

  // @ is an alias to /src
  import OnNapoli from '@/components/OnNapoli.vue'
  import ReelPizza from '@/components/ReelPizza.vue'
  import videoBottom from '@/components/videoBottom.vue'
  import videoTop from '@/components/videoTop.vue'
  import GasBurner from '@/components/GasBurner.vue'
  import SoWhy from '@/components/SoWhy.vue'
  import FoodImages from '@/components/FoodImages.vue'
  import RecipesLink from '@/components/RecipesLink.vue'
  import 'aos/dist/aos.css'
  
  import counterDays from '@/components/counterDays.vue'
  import iconsBanner from '@/components/iconsBanner.vue'
  import questions from '@/components/questions.vue'


  export default {
    name: 'home',
    components: {
      OnNapoli,
      ReelPizza,
      videoBottom,
      videoTop,
      GasBurner,
      SoWhy,
      FoodImages,
      RecipesLink,
      counterDays,
      iconsBanner,
      questions
    },
    mounted() {
      this.$store.dispatch('fbApi', {
        event_name: "ViewContent",
        event_time: Math.floor(new Date() / 1000),
        value: 0,
      })
      //  this.$gtag.event('add_to_wishlist', {
      //       'event_category': 'ecommerce',
      //       'event_label': 'add_to_wishlist'
      //     })
      this.$store.commit('upAutoModel', {routeName: this.$route.name})
    }

  }
</script>

<style scoped>
  img {
    width: 68%;
  }

  .wrap-video {
    height: 374px;
    overflow: hidden;
  }

  video {
    width: 68%;
    margin-top: -188.3px;
  }

  @media (max-width: 767.98px) {
    img {
      width: 100%;
    }

    .wrap-video {
      height: 105px;
    }

    video {
      width: 100%;
      margin-top: -44px;
    }
  }
</style>